// extracted by mini-css-extract-plugin
export var aiStarIcon = "_j8-2";
export var container = "_j8-4";
export var dismissButton = "_j8-3";
export var hasPaddingBottom = "_j8-6";
export var last = "_j8-e";
export var scrollbarThumb = "_j8-c";
export var scrollbarTrack = "_j8-b";
export var selected = "_j8-9";
export var spin = "_j8-1";
export var spinning = "_j8-0";
export var suggestionItem = "_j8-d";
export var suggestionsPanel = "_j8-5";
export var tonePill = "_j8-8";
export var tonesContainer = "_j8-7";
export var unselected = "_j8-a";